// extracted by mini-css-extract-plugin
module.exports = {"participantsContainer":"_09212d3","participantWrapper":"_61e27ea","buttonContainer":"_c69ad13","allOtherScoreRow":"_a3d5420","allOtherScoreRunner":"_6482974"};